import { useLingui } from "@lingui/react/macro";
import { medicalCompetenceDictionary } from "@medoma/models/shifts";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { useEnabledCompetences } from "@/api/Shifts";
import { FilterPicker } from "./FilterPicker";
import { useCompetenceFilter } from "./useCompetenceFilter";

export const CompetenceFilterPicker = () => {
  const { t } = useLingui();
  const {
    data: enabledCompetences,
    isPending,
    isError,
  } = useEnabledCompetences();
  const { selected, setSelected } = useCompetenceFilter();

  if (isPending) {
    return <Loading message={t`Hämtar kompetenser`} />;
  }

  if (isError) {
    return <ErrorMessage message={t`Kunde inte hämta kompetenser`} />;
  }

  const competenceItems = enabledCompetences.map((competence) => ({
    id: competence,
    label: t(medicalCompetenceDictionary[competence].long),
  }));

  return (
    <FilterPicker
      label={t`Kompetenser`}
      items={competenceItems}
      selected={selected}
      onSelectionChange={setSelected}
    />
  );
};
